export default {
  memory: {},
  submittedMemory: null,
  memoryLoading: false,
  submitLoading: false,
};
